module.exports = "<app-leftmenu *jhiHasAnyAuthority=\"['ROLE_CANVAS']\" ></app-leftmenu>\r\n<app-header></app-header>\r\n<router-outlet></router-outlet>\r\n<angular-loader></angular-loader>\r\n<!-- <app-login></app-login>\r\n\r\n<angular-loader></angular-loader>\r\n<div class=\"container-fluid\">\r\n    <nav>\r\n    </nav>\r\n</div>\r\n<div style=\"min-height: 100%\">\r\n    <router-outlet></router-outlet>\r\n</div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main